import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useFirestore} from 'react-redux-firebase'
import {Table, Popup, Icon, Label, Loader, Menu, Button, Placeholder} from 'semantic-ui-react'
import * as SportradarActions from '../../../actions/SportradarActions'
import * as moment from 'moment'

function HeadToHead(props){
    let allTime = {
        'overall': [0, 0, 0],
        'teams': {},
        'history': []
    };

    props.data.AllMeetings.forEach((meeting) => {
        let results = meeting.Matches['Match.Result'];
        let finalResult = null;

        if(typeof results !== 'undefined' && typeof results.Score !== 'undefined')
        for(var score of results.Score){
            if(score.type === 'FT'){
                finalResult = score.value.split(':').map((v) => parseFloat(v));
                break;
            }
        }

        let teams = meeting.Matches['Match.Teams'];
        let teamHome = null;
        let teamAway = null;

        for(var team of teams){
            if(parseInt(team.type) === 1)
                teamHome = team;
            else if(parseInt(team.type) === 2)
                teamAway = team;
        }

        if(teamHome === null)return;
        if(teamAway === null)return;

        if(typeof allTime.teams[teamHome.id] === 'undefined')
            allTime.teams[teamHome.id] = {...teamHome, results: [], won: 0, lost: 0, tie: 0};
        if(typeof allTime.teams[teamAway.id] === 'undefined')
            allTime.teams[teamAway.id] = {...teamAway, results: [], won: 0, lost: 0, tie: 0};

        if(finalResult !== null){
            allTime.teams[teamHome.id].results.push(finalResult[0]);
            allTime.teams[teamAway.id].results.push(finalResult[1]);

            if(finalResult[0] < finalResult[1]){
                allTime.teams[teamHome.id].lost++;
                allTime.teams[teamAway.id].won++;
            }else if(finalResult[0] > finalResult[1]){
                allTime.teams[teamHome.id].won++;
                allTime.teams[teamAway.id].lost++;
            }else{
                allTime.teams[teamHome.id].tie++;
                allTime.teams[teamAway.id].tie++;
            }
        }
    });

    allTime.teams = Object.values(allTime.teams);
    allTime.teams.sort((a, b) => parseInt(a.type) - parseInt(b.type));
    allTime.overall = [allTime.teams[0].won, allTime.teams[0].tie, allTime.teams[0].lost];

    return (
        <div>
            <h4>HeadToHead</h4>

            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell  textAlign="center" width={6}>
                            {allTime.teams[0].translation}
                        </Table.HeaderCell>
                        <Table.HeaderCell  textAlign="center" width={1}>
                            vs.
                        </Table.HeaderCell>
                        <Table.HeaderCell  textAlign="center" width={6}>
                            {allTime.teams[1].translation}
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan={3} textAlign="center">
                            Siege
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell  textAlign="center">
                            {allTime.overall[0]}
                        </Table.Cell>
                        <Table.Cell  textAlign="center">
                            :
                        </Table.Cell>
                        <Table.Cell  textAlign="center">
                            {allTime.overall[2]}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan={3}  textAlign="center">
                            Unentschieden
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan={3}  textAlign="center">
                            {allTime.overall[1]}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan={3}  textAlign="center">
                            Verlauf:
                        </Table.Cell>
                    </Table.Row>
                    {
                        allTime.teams[0].results.map((team1Goals, idx) => {
                            let team2Goals = allTime.teams[1].results[idx];

                            return (
                                <Table.Row>
                                    <Table.Cell  textAlign="center">
                                        <Icon name="trophy" style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'inline-block',
                                            color: (team1Goals > team2Goals)?'#00A700':(team1Goals < team2Goals)?'#FFFFFF':'#FFFFFF'
                                        }}></Icon>
                                    </Table.Cell>
                                    <Table.Cell  textAlign="center">
                                        <Icon name="minus" style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'inline-block',
                                            color: (team1Goals === team2Goals)?'#000000':'#FFFFFF'
                                        }}></Icon>
                                    </Table.Cell>
                                    <Table.Cell  textAlign="center">
                                        <Icon name="trophy" style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'inline-block',
                                            color: (team1Goals < team2Goals)?'#00A700':(team1Goals > team2Goals)?'#FFFFFF':'#FFFFFF'
                                        }}></Icon>
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })
                    }
                </Table.Body>
            </Table>
        </div>
    )
}

export function Prematch(props) {
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const prematch = useSelector((state) => (state.sportradar.getIn(['prematch', 'id']) !== props.id) ? null : state.sportradar.get('prematch').toJS());

    useEffect(() => {
        dispatch(SportradarActions.load_prematch(firestore, props.id));
    }, [props.id])

    return (
        <div style={{
            overflow: 'auto',
            height: '100%'
        }}>
        {
            (prematch === null)?
                <Loader inline active />
            :
                <div>
                    Prematch
                    {
                        (typeof prematch.headtohead !== 'undefined')?
                            <div>
                                <HeadToHead data={prematch.headtohead} />
                            </div>
                        :null
                    }
                </div>
        }
        </div>
    )
}